import config from "@/config";

export default {
  ACCOUNT: {
    dashboard: {
      request: false,
      endPoint: "/dashboard",
      pageId: null,
      validation: ["action_by", "session_token", "audit_by"]
    },
    accountList: {
      request: false,
      endPoint: "/agentlist",
      pageId: "account",
      validation: ["action_by", "session_token"]
    },
    memberList: {
      request: false,
      endPoint: "/memberlist",
      pageId: "account",
      validation: ["action_by", "session_token"]
    },
    blockMember: {
      request: false,
      endPoint: "/blockaccountmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    unblockMember: {
      request: false,
      endPoint: "/unblockaccountmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateMemberStatus: {
      request: false,
      endPoint: "/updateaccountstatusmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "new_status"]
    },
    resetMemberPassword: {
      request: false,
      endPoint: "/resetaccountpasswordmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "new_password"]
    },
    updateMember: {
      request: false,
      endPoint: "/updateaccountprofilemb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_profile_id"]
    },
    memberProviderList: {
      request: false,
      endPoint: "/accountproviderlistmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateMemberProvider: {
      request: false,
      endPoint: "/updateaccountprovidermb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "provider_type", "provider_code", "enable"]
    },
    getMemberBetLimit: {
      request: false,
      endPoint: "/getbetlimitmb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateMemberBetLimitLiveCasino: {
      request: false,
      endPoint: "/updatebetlimitlivemb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "bet_limit_packages"]
    },
    updateMemberBetLimitLottery: {
      request: false,
      endPoint: "/updatebetlimitlotterymb",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "bet_limit_packages"]
    },
    updateMemberBetLimitSports: {
      request: false,
      endPoint: "/updatebetlimitsportsmb",
      pageId: "account",
      validation: [
        "action_by",
        "session_token",
        "target_account_id",
        "soccer_min_bet",
        "soccer_max_bet",
        "soccer_max_per_match",
        "basketball_min_bet",
        "basketball_max_bet",
        "basketball_max_per_match",
        "tennis_min_bet",
        "tennis_max_bet",
        "tennis_max_per_match",
        "baseball_min_bet",
        "baseball_max_bet",
        "baseball_max_per_match",
        "parlay_min_bet",
        "parlay_max_bet",
        "parlay_max_per_match",
        "esports_min_bet",
        "esports_max_bet",
        "esports_max_per_match",
        "others_min_bet",
        "others_max_bet",
        "others_max_per_match"
      ]
    },
    blockAccount: {
      request: false,
      endPoint: "/blockaccount",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    unblockAccount: {
      request: false,
      endPoint: "/unblockaccount",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateStatus: {
      request: false,
      endPoint: "/updateaccountstatus",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "new_status"]
    },
    updateAccount: {
      request: false,
      endPoint: "/updateaccountprofile",
      pageId: "account",
      validation: ["action_by", "session_token", "target_profile_id"]
    },
    resetPassword: {
      request: false,
      endPoint: "/resetaccountpassword",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "new_password"]
    },
    providerList: {
      request: false,
      endPoint: "/accountproviderlist",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateProvider: {
      request: false,
      endPoint: "/updateaccountprovider",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "provider_type", "provider_code", "enable"]
    },
    getBetLimit: {
      request: false,
      endPoint: "/getbetlimit",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id"]
    },
    updateBetLimitLiveCasino: {
      request: false,
      endPoint: "/updatebetlimitlive",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "bet_limit_packages"]
    },
    updateBetLimitLottery: {
      request: false,
      endPoint: "/updatebetlimitlottery",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "bet_limit_packages"]
    },
    updateBetLimitSports: {
      request: false,
      endPoint: "/updatebetlimitsports",
      pageId: "account",
      validation: [
        "action_by",
        "session_token",
        "target_account_id",
        "soccer_min_bet",
        "soccer_max_bet",
        "soccer_max_per_match",
        "basketball_min_bet",
        "basketball_max_bet",
        "basketball_max_per_match",
        "tennis_min_bet",
        "tennis_max_bet",
        "tennis_max_per_match",
        "baseball_min_bet",
        "baseball_max_bet",
        "baseball_max_per_match",
        "parlay_min_bet",
        "parlay_max_bet",
        "parlay_max_per_match",
        "esports_min_bet",
        "esports_max_bet",
        "esports_max_per_match",
        "others_min_bet",
        "others_max_bet",
        "others_max_per_match"
      ]
    },
    addAccount: {
      request: false,
      endPoint: "/addaccount",
      pageId: "account",
      validation: [
        "action_by",
        "session_token",
        "account_id",
        "account_currency",
        "password",
        "bet_limit_packages_casino",
        "bet_limit_packages_lottery",
        "soccer_min_bet",
        "soccer_max_bet",
        "soccer_max_per_match",
        "basketball_min_bet",
        "basketball_max_bet",
        "basketball_max_per_match",
        "tennis_min_bet",
        "tennis_max_bet",
        "tennis_max_per_match",
        "baseball_min_bet",
        "baseball_max_bet",
        "baseball_max_per_match",
        "parlay_min_bet",
        "parlay_max_bet",
        "parlay_max_per_match",
        "esports_min_bet",
        "esports_max_bet",
        "esports_max_per_match",
        "others_min_bet",
        "others_max_bet",
        "others_max_per_match"
      ]
    },
    bankLookup: {
      request: false,
      endPoint: "/banklookup",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    bankGroupList: {
      request: false,
      endPoint: "/bankgrouplist",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    bankList: {
      request: false,
      endPoint: "/banklist",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    bankListForTransfer: {
      request: false,
      endPoint: "/banklist",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    depositBankList: {
      request: false,
      endPoint: "/banklistdeposit",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    withdrawalBankList: {
      request: false,
      endPoint: "/banklistwithdrawal",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    ticketList: {
      request: false,
      endPoint: "/ticketlist",
      pageId: "ticket",
      validation: ["action_by", "session_token", "request_type", "start_date", "end_date"]
    },
    depositTicketList: {
      request: false,
      endPoint: "/ticketlist",
      pageId: "ticket",
      validation: ["action_by", "session_token", "request_type", "start_date", "end_date"]
    },
    withdrawalTicketList: {
      request: false,
      endPoint: "/ticketlist",
      pageId: "ticket",
      validation: ["action_by", "session_token", "request_type", "start_date", "end_date"]
    },
    redepositTicket: {
      request: false,
      endPoint: "/ticketredeposit",
      pageId: "ticket",
      validation: ["action_by", "session_token", "ticket_id"]
    },
    depositTicket: {
      request: false,
      endPoint: "/ticketdeposit",
      pageId: "ticket",
      validation: ["action_by", "session_token", "ticket_id", "action_status"]
    },
    withdrawalTicket: {
      request: false,
      endPoint: "/ticketwithdrawal",
      pageId: "ticket",
      validation: ["action_by", "session_token", "ticket_id", "action_status", "bank_id", "bank_acc_no"]
    },
    dailyWinLoseMember: {
      request: false,
      endPoint: "/dailywinlosemb",
      pageId: "report",
      validation: ["action_by", "session_token", "source_account_id", "start_date", "end_date"]
    },
    dailyWinLoseAgent: {
      request: false,
      endPoint: "/dailywinlose",
      pageId: "report",
      validation: ["action_by", "session_token", "source_account_id", "start_date", "end_date"]
    },
    dailyWinLoseProvider: {
      request: false,
      endPoint: "/dailywinloseprovider",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "start_date", "end_date"]
    },
    dailyWinLoseCode: {
      request: false,
      endPoint: "/dailywinloseprovidercode",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "provider_type", "start_date", "end_date"]
    },
    gameResultLiveCasino: {
      request: false,
      endPoint: "/gameresultlivecasino",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "member_id", "provider_code", "start_date", "end_date"]
    },
    gameResultSlots: {
      request: false,
      endPoint: "/gameresultslots",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "member_id", "provider_code", "start_date", "end_date"]
    },
    gameResultSportsbook: {
      request: false,
      endPoint: "/gameresultsportsbook",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "member_id", "provider_code", "start_date", "end_date"]
    },
    dailyEarningAgent: {
      request: false,
      endPoint: "/dailyearning",
      pageId: "report",
      validation: ["action_by", "session_token", "source_account_id", "start_date", "end_date"]
    },
    dailyEarningProviderAgent: {
      request: false,
      endPoint: "/dailyearningprovider",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "start_date", "end_date"]
    },
    dailyEarningCodeAgent: {
      request: false,
      endPoint: "/dailyearningprovidercode",
      pageId: "report",
      validation: ["action_by", "session_token", "account_id", "provider_type", "start_date", "end_date"]
    },
    dailyEarningByDate: {
      request: false,
      endPoint: "/dailyearningbydate",
      pageId: "report",
      validation: ["action_by", "session_token", "source_account_id", "start_date", "end_date"]
    },
    bankGroupList: {
      request: false,
      endPoint: "/bankgrouplist",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    bankAccountGroupList: {
      request: false,
      endPoint: "/bankgroupbankacclist",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id"]
    },
    addBankAccountGroup: {
      request: false,
      endPoint: "/addbankgroupbankacc",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id", "bank_id", "bank_acc_no"]
    },
    deleteBankAccountGroup: {
      request: false,
      endPoint: "/deletebankgroupbankacc",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id", "bank_id", "bank_acc_no"]
    },
    defaultBankGroup: {
      request: false,
      endPoint: "/defaultbankgroup",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id"]
    },
    editBankGroup: {
      request: false,
      endPoint: "/editbankgroup",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id", "group_name"]
    },
    addBankGroup: {
      request: false,
      endPoint: "/addbankgroup",
      pageId: "bank",
      validation: ["action_by", "session_token", "group_id", "group_name", "is_default"]
    },
    memberBankList: {
      request: false,
      endPoint: "/banklistmember",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    updateMemberBankStatus: {
      request: false,
      endPoint: "/updatebankstatusmember",
      pageId: "bank",
      validation: ["action_by", "session_token", "member_id", "bank_id", "bank_acc_no", "new_status"]
    },
    updateMemberBank: {
      request: false,
      endPoint: "/updatebankmember",
      pageId: "bank",
      validation: ["action_by", "session_token", "member_id", "bank_id", "bank_acc_no"]
    },
    dailyStatement: {
      request: false,
      endPoint: "/dailystatement",
      pageId: "report",
      validation: ["action_by", "session_token", "source_account_id", "target_account_id", "start_date", "end_date"]
    },
    dailyBankStatement: {
      request: false,
      endPoint: "/bankdailystatement",
      pageId: "report",
      validation: ["action_by", "session_token", "bank_id", "bank_acc_no", "working_date"]
    },
    bankStatement: {
      request: false,
      endPoint: "/bankstatement",
      pageId: "report",
      validation: ["action_by", "session_token", "bank_id", "bank_acc_no", "working_month"]
    },
    updateBankStatus: {
      request: false,
      endPoint: "/updatebankstatus",
      pageId: "bank",
      validation: ["action_by", "session_token", "bank_id", "bank_acc_no", "new_status"]
    },
    addCompanyBank: {
      request: false,
      endPoint: "/addcompanybank",
      pageId: "bank",
      validation: [
        "action_by",
        "session_token",
        "bank_id",
        "bank_acc_no",
        "bank_acc_holder",
        "bank_acc_type",
        "incoming_amount_threshold",
        "incoming_frequency_threshold",
        "outgoing_amount_threshold",
        "outgoing_frequency_threshold",
        "account_balance",
        "bank_group_id"
      ]
    },
    editCompanyBank: {
      request: false,
      endPoint: "/editcompanybank",
      pageId: "bank",
      validation: [
        "action_by",
        "session_token",
        "bank_id",
        "bank_acc_no",
        "bank_acc_holder",
        "bank_acc_type",
        "incoming_amount_threshold",
        "incoming_frequency_threshold",
        "outgoing_amount_threshold",
        "outgoing_frequency_threshold"
      ]
    },
    resetBankAmount: {
      request: false,
      endPoint: "/resetbankamount",
      pageId: "bank",
      validation: ["action_by", "session_token", "bank_id", "bank_acc_no", "incoming_amount_threshold", "incoming_frequency_threshold", "outgoing_amount_threshold", "outgoing_frequency_threshold"]
    },
    adjustBank: {
      request: false,
      endPoint: "/adjustbank",
      pageId: "bank",
      validation: ["action_by", "session_token", "bank_id", "bank_acc_no", "amount"]
    },
    bankSettingList: {
      request: false,
      endPoint: "/banksettinglist",
      pageId: "bank",
      validation: ["action_by", "session_token"]
    },
    updateBankSetting: {
      request: false,
      endPoint: "/updatebanksetting",
      pageId: "bank",
      validation: ["action_by", "session_token", "banking_mode", "new_status"]
    },
    bankTansfer: {
      request: false,
      endPoint: "/transferbank",
      pageId: "bank",
      validation: ["action_by", "session_token", "amount", "sender_bank_id", "sender_bank_acc_no", "recipient_bank_id", "recipient_bank_acc_no"]
    },
    getBankTAC: {
      request: false,
      endPoint: "/getbanktac",
      pageId: "bank",
      validation: ["action_by", "session_token", "member_id"]
    },
    ticketPending: {
      request: false,
      endPoint: "/ticketpending",
      pageId: "ticket",
      validation: ["action_by", "session_token"]
    },
    transferLog: {
      request: false,
      endPoint: "/transferlog",
      pageId: "log",
      validation: ["action_by", "session_token", "source_account_id", "target_account_id", "start_date", "end_date"]
    },
    accountLog: {
      request: false,
      endPoint: "/accountlog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    agentLoginLog: {
      request: false,
      endPoint: "/agentloginlog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    memberLoginLog: {
      request: false,
      endPoint: "/memberloginlog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    profileLog: {
      request: false,
      endPoint: "/profilelog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    authorityLog: {
      request: false,
      endPoint: "/accountauthoritylog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    betLimitLog: {
      request: false,
      endPoint: "/betlimitlog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    betLimitSportsLog: {
      request: false,
      endPoint: "/betlimitsportslog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    actionLog: {
      request: false,
      endPoint: "/actionlog",
      pageId: "log",
      validation: ["action_by", "session_token", "search_id", "start_date", "end_date"]
    },
    transferHistory: {
      request: false,
      endPoint: "/membertransferhistory",
      pageId: "report",
      validation: ["action_by", "session_token", "member_id"]
    },
    adjustMember: {
      request: false,
      endPoint: "/adjustmember",
      pageId: "account",
      validation: ["action_by", "session_token", "account_id", "transfer_amount"]
    },
    manualWithdrawal: {
      request: false,
      endPoint: "/ticketwithdrawalmanual",
      pageId: "ticket",
      validation: ["action_by", "session_token", "member_id", "amount", "bank_id", "bank_acc_no", "ref_no"]
    },
    manualDeposit: {
      request: false,
      endPoint: "/ticketdepositmanual",
      pageId: "ticket",
      validation: ["action_by", "session_token", "member_id", "amount", "bank_id", "bank_acc_no", "bank_acc_no", "ref_no"]
    },
    memberTac: {
      request: false,
      endPoint: "/getmembertac",
      pageId: "account",
      validation: ["action_by", "session_token", "member_id"]
    },
    platformFee: {
      request: false,
      endPoint: "/getplatformfee",
      pageId: "account",
      validation: ["action_by", "session_token"]
    },
    updatePlatformFee: {
      request: false,
      endPoint: "/updateplatformfee",
      pageId: "account",
      validation: ["action_by", "session_token", "fee"]
    },
    memberTacList: {
      request: false,
      endPoint: "/membertaclist",
      pageId: "account",
      validation: ["action_by", "session_token", "tac_status"]
    },
    memberTacActive: {
      request: false,
      endPoint: "/membertacactivate",
      pageId: "account",
      validation: ["action_by", "session_token", "member_id", "refer_member_id"]
    },
    memberAgTacActive: {
      request: false,
      endPoint: "/memberagtacactivate",
      pageId: "account",
      validation: ["action_by", "session_token", "member_id", "agent_id"]
    },
    dailyCount: {
      request: false,
      endPoint: "/dailycount",
      pageId: "account",
      validation: ["action_by", "session_token", "target_account_id", "start_date", "end_date"]
    }
  },
  GAME: {
    UU: process.env.VUE_APP_API_UU,
    LIVE22: process.env.VUE_APP_API_LIVE22,
    PPS: process.env.VUE_APP_API_PPS,
    YB: process.env.VUE_APP_API_YB,
    EVO: process.env.VUE_APP_API_EVO,
    PPC: process.env.VUE_APP_API_PPC,
    EPIC: process.env.VUE_APP_API_EPIC,
    MEGA: process.env.VUE_APP_API_MEGA
  },
  doRequest(args, target) {
    const url = config.getBaseUrl() + config.userBaseUrl + target.endPoint;
    const feedback = {
      success: false,
      status: "requestFailed",
      message: null,
      data: null,
      source: "doRequests"
    };
    return new Promise((resolve, reject) => {
      if (target.request == true) {
        feedback.status = "requestLimit";
        reject(feedback);
        return;
      }
      if (!args) {
        feedback.status = "requestIncompleted";
        reject(feedback);
        return;
      }
      for (var i = 0; i < target.validation.length; i++) {
        if (!(target.validation[i] in args)) {
          feedback.status = "requestIncompleted";
          reject(feedback);
          return;
        }
      }
      args["page_id"] = target.pageId;
      target.request = true;
      fetch(url, {
        method: "POST",
        body: JSON.stringify(args),
        headers: { "Content-Type": "application/json" }
      })
        .then(res => res.text())
        .then(res => {
          target.request = false;
          feedback.success = true;
          feedback.status = "ok";
          var data = JSON.parse(res);
          if (data) {
            if (typeof data.status == "string") {
              feedback.success = data.status == "1";
            } else {
              feedback.success = data.status == 1;
            }
            feedback.status = data.statusdesc;

            if (feedback.success == true) {
              try {
                feedback.data = data.value;
                resolve(feedback);
              } catch (error) {
                feedback.success = false;
                feedback.status = "requestFailed";
                feedback.message = error.message;
                reject(feedback);
              }
            } else {
              reject(feedback);
            }
          } else {
            reject(feedback);
          }
        })
        .catch(res => {
          target.request = false;
          feedback.success = false;
          feedback.status = "requestFailed";
          feedback.message = res.message;
          reject(feedback);
        });
    });
  },
  doGame(args, url) {
    const feedback = {
      success: false,
      status: "requestFailed",
      message: null,
      data: null,
      source: "doGame"
    };
    return new Promise((resolve, reject) => {
      if (!args) {
        feedback.status = "requestIncompleted";
        reject(feedback);
        return;
      }
      fetch(url, {
        method: "POST",
        body: JSON.stringify(args),
        headers: { "Content-Type": "application/json" }
      })
        .then(res => res.text())
        .then(res => {
          feedback.success = true;
          feedback.status = "ok";
          feedback.data = res;
          resolve(feedback);
        })
        .catch(res => {
          feedback.success = false;
          feedback.status = "requestFailed";
          feedback.message = res.message;
          reject(feedback);
        });
    });
  },
  getIP() {
    return new Promise(resolve => {
      fetch("https://api.ipify88.com", { timeout: 2000 })
        .then(response => response.text())
        .then(data => {
          resolve(data);
        })
        .catch(err => resolve(""));
    });
  }
};
